/**
 * i18n Configuration
 * Internationalization setup using react-i18next
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import pt_br from './locales/pt_br.json';

export const resources = {
  en: { translation: en },
  pt_br: { translation: pt_br },
} as const;

export type SupportedLanguage = 'en' | 'pt_br';

// Map backend language codes to i18n codes
export const languageMap: Record<string, SupportedLanguage> = {
  EN: 'en',
  PT_BR: 'pt_br',
};

// Map i18n codes to backend codes
export const backendLanguageMap: Record<SupportedLanguage, string> = {
  en: 'EN',
  pt_br: 'PT_BR',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt_br',
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ff_language',
    },
  });

export default i18n;
